import { CommonModule } from '@angular/common';
import { PieChartModule } from 'ChartApp/ts/features/pie-chart/pie-chart.module';
import { ConfigModule } from 'NewAngular/config/config.module';
import { SingleSelectDropdownModule } from 'NewAngular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TopHoldingsComponent } from './top-holdings.component';
import * as i0 from "@angular/core";
export class TopHoldingsModule {
}
TopHoldingsModule.ɵfac = function TopHoldingsModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TopHoldingsModule)(); };
TopHoldingsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: TopHoldingsModule, bootstrap: [TopHoldingsComponent] });
TopHoldingsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, ConfigModule, IconModule, PieChartModule, SingleSelectDropdownModule] });
